var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerNavbraSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41932 14.0164C6.41932 15.1281 6.63062 16.229 7.04117 17.2561C7.45171 18.2832 8.05345 19.2164 8.81204 20.0025C9.57062 20.7886 10.4712 21.4122 11.4623 21.8376C12.4535 22.2631 13.5158 22.482 14.5886 22.482V14.0164H6.41932Z",
    fill: "#FFC556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41932 14.0168C6.41932 12.9051 6.63062 11.8042 7.04117 10.7771C7.45171 9.75004 8.05345 8.81679 8.81204 8.03069C9.57062 7.24458 10.4712 6.62101 11.4623 6.19557C12.4535 5.77013 13.5158 5.55116 14.5886 5.55116V14.0168H6.41932Z",
    fill: "#8DD5AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09581 26.2517L8.57161 21.6672L10.7263 22.9262L7.09581 26.2517Z",
    fill: "#FFC556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2539 27.9115L11.2961 23.2043L13.8198 23.3542L12.2539 27.9115Z",
    fill: "#FFC556"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22793 22.9268L6.31353 19.1358L7.86055 21.0387L3.22793 22.9268Z",
    fill: "#FFC556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.762255 18.8596L4.96991 16.2205L5.78764 18.4968L0.762255 18.8596Z",
    fill: "#FFC556"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0156053 14.1561L4.90751 13.003L4.88048 15.4085L0.0156053 14.1561Z",
    fill: "#FFC556"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0166144 14.1561L4.90852 13.003L4.90852 14.2939L0.0166144 14.1561Z",
    fill: "#8DD5AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.850318 9.33351L5.84214 9.99369L4.87679 12.2171L0.850318 9.33351Z",
    fill: "#8DD5AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3248 5.18528L7.77026 7.44414L6.0575 9.21387L3.3248 5.18528Z",
    fill: "#8DD5AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23862 1.75774L10.7054 5.23775L8.49243 6.40159L7.23862 1.75774Z",
    fill: "#8DD5AD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.251 0.123978L13.946 4.63924L11.4275 4.85414L12.251 0.123978Z",
    fill: "#8DD5AD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7565 14.0164C22.7565 15.1281 22.5452 16.229 22.1346 17.2561C21.7241 18.2832 21.1223 19.2164 20.3637 20.0025C19.6052 20.7886 18.7046 21.4122 17.7135 21.8376C16.7223 22.2631 15.66 22.482 14.5872 22.482V14.0164H22.7565Z",
    fill: "#FFC556"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7565 14.0168C22.7565 12.9051 22.5452 11.8042 22.1346 10.7771C21.7241 9.75004 21.1223 8.81679 20.3637 8.03069C19.6052 7.24458 18.7046 6.62101 17.7135 6.19557C16.7223 5.77013 15.66 5.55116 14.5872 5.55116V14.0168H22.7565Z",
    fill: "#8DD5AD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.08 26.2517L20.6042 21.6672L18.4494 22.9262L22.08 26.2517Z",
    fill: "#FFC556"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9219 27.9115L17.8797 23.2043L15.3559 23.3542L16.9219 27.9115Z",
    fill: "#FFC556"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9479 22.9268L22.8622 19.1358L21.3152 21.0387L25.9479 22.9268Z",
    fill: "#FFC556"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4135 18.8596L24.2059 16.2205L23.3881 18.4968L28.4135 18.8596Z",
    fill: "#FFC556"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1602 14.1561L24.2683 13.003L24.2953 15.4085L29.1602 14.1561Z",
    fill: "#FFC556"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1592 14.1561L24.2673 13.003L24.2673 14.2939L29.1592 14.1561Z",
    fill: "#8DD5AD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3255 9.33351L23.3336 9.99369L24.299 12.2171L28.3255 9.33351Z",
    fill: "#8DD5AD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.851 5.18528L21.4055 7.44414L23.1183 9.21387L25.851 5.18528Z",
    fill: "#8DD5AD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9372 1.75774L18.4703 5.23775L20.6834 6.40159L21.9372 1.75774Z",
    fill: "#8DD5AD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9248 0.123978L15.2297 4.63924L17.7483 4.85414L16.9248 0.123978Z",
    fill: "#8DD5AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerNavbraSun);
export default __webpack_public_path__ + "static/media/ManagerNavbraSun.fb0f1c82f3a1b7a5dc5e79a08f6181ff.svg";
export { ForwardRef as ReactComponent };